<template>
  <div class="new_user">
    <ul class="type_ul" v-if="questiontypeList && questiontypeList.length > 0">
      <li 
        class="type_li" 
        v-for="(item, index) in questiontypeList" 
        :key="item._id" 
        :style="`height:${ getHeight(item) }`" 
        >
        <div class="li_header" :class="item.expand ? 'mb-0':'mb-20'" @click="handleClick(item)">
          <span>{{ (index + 1) + '、' + item.name }}</span>
          <img :class="item.expand ? 'rotate_reverse' : 'rotate'" src="../../../assets/images/client/arrow_down.png" alt="">
        </div>
        <ul>
          <div v-show="item.expand">
            <li class="li_content" v-for="v in item.children" :key="v._id">
              <router-link :to="{ name:'QuestionDetail', query: { id: v._id, type: 'beginner' }}">
                {{v.title ? '• ' + v.title : ''}}
              </router-link>
            </li>
            <li class="li_content empty" v-show="item.children.length === 0 && item.onload">暂无内容</li>
          </div>
        </ul>
      </li>
    </ul>
    <div class="empty" v-if="questiontypeList && questiontypeList.length === 0">暂无内容</div>
    <!-- 分页 -->
    <el-pagination
      v-if="total > pageSize"
      background
      class="page"
      @size-change="handleSizeChange" 
      @current-change="handleCurrentChange" 
      :current-page="pageNum" 
      :page-sizes="[10, 20, 30, 40]" 
      :page-size="pageSize" 
      layout="sizes, total, prev, pager, next, jumper" 
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'NewUser',
  data() {
    return {
      pageSize:10,
      pageNum:1,
      total:0,
      questiontypeList:[],//问题类型列表
    };
  },
  computed: {
    ...mapState({
      currentClient: state=>state.User.currentClient,
      productionId: state=>state.ProductManager.productionId,
    })
  },
  watch:{
    productionId:{
      handler(val){
        if(val){
          // 主题类型
          this.getThemeClientInfo();
        }
      },
      immediate:true
    }
  },
  mounted() {
    
  },

  methods: {
    ...mapActions(['themeClientInfo', 'beginnerInfoClientInfo']),
    getHeight(item){
      return item.expand ? (item.children.length > 0 ? item.children.length * 36 + 58 + 'px' : '86px') : '50px';
    },
    // 分页
    handleSizeChange(size) {
      this.pageSize = size;
      this.getThemeClientInfo();
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.getThemeClientInfo();
    },
    // 获取主题分类
    getThemeClientInfo(){
      this.themeClientInfo({
        "category": this.currentClient,   //产品端  B端:"2B" C端:"2C"
        "productionId": this.productionId, //关联的产品类型
        p: this.pageNum,
        s: this.pageSize   
      }).then(res => {
        this.questiontypeList = res.items.map(item => {
          return {
            ...item,
            onload: false,//控制加载状态
            children: [],//子集
            expand: false//控制展开状态
          }
        });
        this.total = res.total;
      })
    },

    handleClick(item){
      item.expand = !item.expand;
      item.children.length > 0 ? null : this.getBeginnerInfoClientInfo(item);
    },
    // 根据问题类型获取问题列表
    getBeginnerInfoClientInfo(item){
      this.beginnerInfoClientInfo({
        "category": this.currentClient,   //产品端  B端:"2B" C端:"2C"
        "productionId": this.productionId, //关联的产品类型
        "themeId": item._id, //主题类型
      }).then(res => {
        item.onload = true;
        this.$set(item, 'children', res)
      })
    },
  },
};
</script>

<style lang="sass" rel="stylesheet/scss" scoped>
.new_user {
  .type_ul {
    margin: 20px auto 0;
    min-height: 300px;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
    .type_li {
      transition: all 0.3s ease;
      overflow: hidden;
      .li_header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 30px;
        background-color: #f4f4f4;
        padding: 0 10px;
        margin-bottom: 20px;
        cursor: pointer;
        span{
          display: inline-block;
          line-height: 36px;
          font-size: 14px;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
        img{
          width: 12px;
        }
        .rotate{
          transition: all 0.3s;
          transform: rotate(0deg);
        }
        .rotate_reverse{
          transition: all 0.3s;
          transform: rotate(-180deg);
        }
      }
      .mb-0{
        margin-bottom: 0;
      }
      .mb-20{
        margin-bottom: 20px;
      }
      .li_content{ 
        a{
          display: flex;
          font-size: 14px;
          color: #333;
          line-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        a:hover{
          color: #1daef8;
          text-decoration: none;
        }
      }
      .li_content:first-child{
        margin-top: 9px;
      }
      .li_content:last-child{
        margin-bottom: 9px;
      }
      .empty{
        text-align: center;
        cursor: default;
        color: #999;
      }
      .empty:hover{
        color: #999;
      }
    }
    li:hover{
      .empty{
        color: #999;
        cursor: default;
      }
    }
  }
  .type_ul::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .page{
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .empty{
    text-align: center;
    margin-top: 20px;
    color: #999;
    cursor: default;
  }
}
</style>


// WEBPACK FOOTER //
// newUser.vue?2da6c5ea